module.exports = __webpack_public_path__ + "media/images/download-79bf6666a96eeb98f98a186dd15ff732.png";